@if (isDashboardPage || !isLoggedIn) {
<div
  class="bg-container"
  [ngClass]="[
    isDashboardPage
      ? isSymphonyAccount
        ? 'symphony-dashboard'
        : 'dashboard-page'
      : ''
  ]"
>
  <div class="arc-container">
    <img
      [src]="
        isDashboardPage
          ? '/assets/images/bg-curve-dashboard.svg'
          : '/assets/images/bg-curve-landing.svg'
      "
      class="arc"
      alt="Background Curve image"
      aria-hidden="true"
    />
  </div>
</div>
}
<main
  class="fg-container"
  [ngClass]="[!isLoggedIn ? 'login-landing-page' : '']"
>
  <div class="container-fluid">
    <ng-container *ngTemplateOutlet="containerTemplate"></ng-container>
  </div>
</main>
